import log from '@common-sense-privacy/common/dist/src/log/browser'

export default log
